module.exports = __webpack_public_path__ + "img/eco-qr.3d65bdf7.png";